import { useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'

import { env } from '@/env'

import { setAccessToken } from '../graphqlAuth'
import { disposeSubscriptionClient } from '../subscriptionClient'
import { disposePositionClient } from './usePositionStreamSubscription'

export function useGraphqlAuth(): void {
  const auth = useAuth()
  const token = auth.user?.access_token ?? null
  const hadTokenRef = useRef(false)

  useEffect(() => {
    if (!env.VITE_AUTH_ENABLED) {
      return
    }

    setAccessToken(token)

    if (token && !hadTokenRef.current) {
      hadTokenRef.current = true
      disposeSubscriptionClient()
      disposePositionClient()
    } else if (!token && hadTokenRef.current) {
      hadTokenRef.current = false
      disposeSubscriptionClient()
      disposePositionClient()
    }
  }, [token])
}
